import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  mandalData: object;

  constructor(
    private http: HttpClient,
    private utils: UtilsService
  ) { }

  getMandalData(url, postData) {
    const promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  getDistrictData(url, postData) {
    const promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  formatDistrictData(data) {
    const finalData = {};
    const timeStampList = [];
    const tableData = [];
    for (const locName in data) {
      if (!isNullOrUndefined(locName)) {
        const locObject = {};
        locObject['District'] = { val: this.utils.formatNames(data[locName]['name']) };
        for (const element in data[locName]['table_data']) {
          if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
            continue;
          }
          const timeStamp = data[locName]['table_data'][element]['timeStamp'];
          if (!timeStampList.includes(timeStamp)) {
            timeStampList.push(timeStamp);
          }
          const timeC = timeStamp.toString() + '_' + 'c';
          locObject[timeC] = { val: data[locName]['table_data'][element]['data']['c'] };
          const timeD = timeStamp.toString() + '_' + 'd';
          locObject[timeD] = { val: data[locName]['table_data'][element]['data']['d'] };
        }
        // console.log(data[locName]);
        if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
          locObject['centroid'] = data[locName]['centroid'];
        }
        tableData.push(locObject);
      }
    }
    const sortedTimeStampList = timeStampList.sort();
    const column1 = [];
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'District',
    });
    const column2 = [];
    const tableHeaders = [];
    tableHeaders.push({ val: 'District' });
    for (const index in sortedTimeStampList) {
      if (!isNullOrUndefined(index)) {
        const tp = sortedTimeStampList[index];
        column1.push({
          val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
          colspan: 2,
          rowspan: 1,
          sortedHeaderVal: tp.toString() + '_d'
        });
        column2.push({
          val: 'C',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
          sortedHeaderVal: tp.toString() + '_c'
        });
        column2.push({
          val: 'D',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
          sortedHeaderVal: tp.toString() + '_d'
        });
        tableHeaders.push({
          val: tp.toString() + '_c'
        });
        tableHeaders.push({
          val: tp.toString() + '_d'
        });
      }
    }
    const tableColumns = [];
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = tableData;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatMandalData(data, hval, hcat) {
    const finalData = {};
    let tableDataForMandal = [];
    const timeStampList = [];
    for (const locName of Object.keys(data)) {
      if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
        continue;
      }
      const locObject = {};
      for (const index of data[locName]['table_data']) {
        if (!timeStampList.includes(index['timeStamp'])) {
          timeStampList.push(index['timeStamp']);
        }
        if (!(Number(index['data'][hval]).toFixed(2) == 'NaN')) {
          locObject[index['timeStamp']] = {
            val: Number(index['data'][hval]).toFixed(2),
            backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND[index['data'][hcat]]
          };
        }
      }
      locObject['District'] = { val: this.utils.formatNames(data[locName]['pName']) };
      locObject['Mandal'] = { val: this.utils.formatNames(data[locName]['name']) };
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      tableDataForMandal.push(locObject);
    }
    const sortedTimeStampList = timeStampList.sort();
    const column1 = [];
    column1.push({
      val: 'Mandal',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'Mandal',
    });
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'District',
    });
    const tableHeaders = [];
    tableHeaders.push({ val: 'Mandal' });
    tableHeaders.push({ val: 'District' });
    for (const index in sortedTimeStampList) {
      if (!isNullOrUndefined(index)) {
        const tp = sortedTimeStampList[index];
        column1.push({
          val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: tp.toString()
        });
        tableHeaders.push({
          val: tp.toString()
        });
      }
    }
    const tableColumns = [];
    tableColumns.push(column1);
    finalData['data'] = tableDataForMandal;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatChartData(data, chartDataString) {
    const timeStampList = [];
    const blockArray = [];
    const formattedChartData = [{}, {}, {}];
    formattedChartData[0][chartDataString] = 'Danger';
    formattedChartData[1][chartDataString] = 'Caution';
    formattedChartData[2][chartDataString] = 'Normal';
    const chartData = {
      Danger: {},
      Caution: {},
      Normal: {}
    };
    for (const locName in data) {
      if (!isNullOrUndefined(locName)) {
        for (const element in data[locName]['table_data']) {
          if (!isNullOrUndefined(element)) {
            if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
              continue;
            }
            const timeStamp = data[locName]['table_data'][element]['timeStamp'];
            if (!timeStampList.includes(timeStamp)) {
              timeStampList.push(timeStamp);
            }
            const date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
            if (chartData['Danger'][date] == undefined && formattedChartData[0][date] == undefined) {
              chartData['Danger'][date] = data[locName]['table_data'][element]['data']['d'];
              formattedChartData[0][date] = data[locName]['table_data'][element]['data']['d'];
            } else {
              chartData['Danger'][date] += data[locName]['table_data'][element]['data']['d'];
              formattedChartData[0][date] += data[locName]['table_data'][element]['data']['d'];
            }
            if (chartData['Caution'][date] == undefined && formattedChartData[1][date] == undefined) {
              chartData['Caution'][date] = data[locName]['table_data'][element]['data']['c'];
              formattedChartData[1][date] = data[locName]['table_data'][element]['data']['c'];
            } else {
              chartData['Caution'][date] += data[locName]['table_data'][element]['data']['c'];
              formattedChartData[1][date] += data[locName]['table_data'][element]['data']['c'];
            }
            if (chartData['Normal'][date] == undefined && formattedChartData[2][date] == undefined) {
              chartData['Normal'][date] = data[locName]['table_data'][element]['data']['n'];
              formattedChartData[2][date] = data[locName]['table_data'][element]['data']['n'];
            } else {
              chartData['Normal'][date] += data[locName]['table_data'][element]['data']['n'];
              formattedChartData[2][date] += data[locName]['table_data'][element]['data']['n'];
            }
          }
        }
      }
    }
    const sortedTimeStampList = timeStampList.sort();
    for (const tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray];
  }

  setBlockNumber() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let index;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      index = 1;
    } else {
      // Before 5:30 PM
      index = 0;
    }
    return index;
  }
}
